import {ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation} from "@angular/core";

@Component({
  selector: "n-global-styles",
  template: "",
  styleUrls: [
    "./n-global-styles.css"
  ],
  styles: [],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class NGlobalStylesComponent {

}
